import { render, staticRenderFns } from "./editMultipleUserRight.vue?vue&type=template&id=ba47d4dc&scoped=true&"
import script from "./editMultipleUserRight.vue?vue&type=script&lang=js&"
export * from "./editMultipleUserRight.vue?vue&type=script&lang=js&"
import style0 from "./editMultipleUserRight.vue?vue&type=style&index=0&id=ba47d4dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba47d4dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
